import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { OutputService } from 'app/infrastructure/services/output.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { Translator } from 'angular-translator';
import { OutputPushModel } from 'app/infrastructure/model/interfaces/output.interface';

@Component({
    selector: 'sx-push-configuration',
    templateUrl: './pushConfiguration.component.html',
})

export class PushConfigurationComponent implements OnInit {

    systemCode: string;
    outputCode: string;

    datefrom: Date;
    dateto: Date;
    idfrom= '';
    idto= '';

    pushModel: OutputPushModel = {
        systemCode: '',
        outputCode : '',
        pushType: 'existingQueue',
        pushFrom: null,
        pushTo: null,
        executeRule: false,
        pushList: ''
    };

    pushValues = [
        { value: 'pushExistingQueue', description: 'PUSH_EXISTING' },
        { value: 'pushDateRange', description: 'PUSH_DATE_RANGE' },
        { value: 'pushDocumentRange', description: 'PUSH_DOCUMENT_RANGE' },
        { value: 'pushCustomList', description: 'PUSH_LIST' },
    ];

    nextQueue: String;

    docsIds = [];

    showDateRange = false;
    showDocumentRange = false;
    showCustomList = false;

    showResult = false;
    resultRef= '';

    constructor(private outputService: OutputService,
                private router: Router,
                private aRoute: ActivatedRoute,
                private alert: AlertService,
                private translator: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.pushModel.outputCode = this.outputCode;
            this.pushModel.systemCode = this.systemCode;

            this.outputService.getNextExecution(this.systemCode, this.outputCode)
            .subscribe(res => { this.nextQueue = res; });
        });
   }

   onpushValueChange(config: any) {
        this.pushModel.pushType = config.value;

        if (config.value === 'pushDateRange') {
            this.showDateRange = true;
            this.showDocumentRange = false;
            this.showCustomList = false;
            return;
        }

        if (config.value === 'pushCustomList') {
            this.showDateRange = false;
            this.showDocumentRange = false;
            this.showCustomList = true;
            return;
        }

        if (config.value === 'pushDocumentRange') {
            this.showDateRange = false;
            this.showDocumentRange = true;
            this.showCustomList = false;
            return;
        }

        this.showDateRange = false;
        this.showDocumentRange = false;
        this.showCustomList = false;
        return;
    }

    goBack(){
        // this.router.navigate(['../']);
        this.router.navigate(['../'], { relativeTo: this.aRoute });
    }

    theListChosen(event){
        this.pushModel.pushList = event;
    }

    pushOutput() {
        if (this.pushModel.pushType === 'pushCustomList' ){
            if (this.pushModel.pushList === ''){
                this.alert.showGrowl({
                    type: GrowlType.DANGER,
                    body: <string>this.translator.instant('CANT_SEND_EMPTY_LIST'),
                });
                return;
            }
            this.outputService.getPushableDocuments(this.pushModel).then(res => {
                if (!res) {
                    this.alert.showGrowl({
                        type: GrowlType.DANGER,
                        body: <string>this.translator.instant('ERROR_LIST_OUTPUT_PUSH'),
                    });
                }else{
                    this.outputService.sendPush(this.pushModel).then(res => {
                        if (res.success) {
                                this.showResult = true;
                                this.resultRef = res.uri;
                        } else {
                            this.alert.showGrowl({
                                type: GrowlType.DANGER,
                                body: <string>this.translator.instant('ERROR_GENERATING_OUTPUT'),
                            });
                        }
                    });
                }
            });
            return;
        }else{
            if (this.showDateRange){
                this.pushModel.pushFrom = this.datefrom;
                this.pushModel.pushTo = this.dateto;
            }
            if (this.showDocumentRange){
                this.pushModel.pushFrom = Number(this.idfrom);
                this.pushModel.pushTo = Number(this.idto);
            }

            if (this.pushModel.pushFrom > this.pushModel.pushTo && ( this.showDateRange || this.showDocumentRange)){
                this.alert.showGrowl({
                    type: GrowlType.DANGER,
                    body: <string>this.translator.instant('NONSENSE_RANGE'),
                });
                return;
            }

            this.outputService.sendPush(this.pushModel).then(res => {
                if (res.success) {
                        this.showResult = true;
                        this.resultRef = res.uri;
                } else {
                    this.alert.showGrowl({
                        type: GrowlType.DANGER,
                        body: <string>this.translator.instant('ERROR_GENERATING_OUTPUT'),
                    });
                }
            });
        }
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/pushConfiguration/pushConfiguration.component.ts